import { queryKeys } from '@query/keys'
import { useQuery } from '@tanstack/react-query'

import { useApiClient } from '@utils/ApiClient'
import { ClientApiClient } from '@utils/clientApi'

import type { WalletPaymentProvider } from '@model/WalletPaymentProvider'

export const useWithdrawalMethods = (params: { locale: string; walletId?: string }) => {
  const { locale, walletId } = params
  const apiClient = useApiClient(ClientApiClient)

  const { data, isLoading } = useQuery({
    queryKey: queryKeys.walletExtended.withdrawalMethods(locale, walletId),
    queryFn: () => apiClient.getWalletWithdrawalMethods(locale, walletId!),
    enabled: !!walletId,
  })

  return {
    methods: (data ?? []) as WalletPaymentProvider[],
    isMethodsLoading: isLoading,
  }
}
